<template>
  <Navigation :title="$t('createTransaction.title')" />

  <div class="detail-hero bg-finger">
    <div class="hero-spacer"></div>
  </div>

  <div class="detail-body">
    <div class="detail-summary">
      <span class="pkg-name">{{ pkg.name }}</span>
      <span class="pkg-target">{{ pkg.grouping }}</span>
      <span class="pkg-counselor" v-if="pkg.counselor_name"> {{ $t('selectedCounselor') }}: {{ pkg.counselor_name }} </span>
      <span class="pkg-price">{{ formatPrice(pkg.total_price) }}</span>
    </div>

    <section class="detail-section">
      <div class="card-priadi form-card">
        <p class="form-card-title">{{ $t('createTransaction.title') }}</p>
        <p class="form-card-subtitle">{{ $t('createTransaction.subtitle') }}</p>

        <div class="form-group">
          <label class="form-label-priadi" for="nama">{{ $t('fullname') }}</label>
          <input
            type="text"
            class="form-control-priadi"
            :class="{ 'is-invalid': errors.nama }"
            id="nama"
            :placeholder="$t('fullnameHint')"
            v-model="nama" />
          <p class="form-error-priadi" v-if="errors.nama">{{ errors.nama }}</p>
        </div>

        <div class="form-group">
          <label class="form-label-priadi" for="email">{{ $t('email') }}</label>
          <input
            type="email"
            class="form-control-priadi"
            :class="{ 'is-invalid': errors.email }"
            id="email"
            :placeholder="$t('emailHint')"
            v-model="email" />
          <p class="form-error-priadi" v-if="errors.email">{{ errors.email }}</p>
        </div>

        <div class="form-group">
          <label class="form-label-priadi" for="phone">{{ $t('phone') }}</label>
          <input
            type="tel"
            class="form-control-priadi"
            :class="{ 'is-invalid': errors.phone }"
            id="phone"
            :placeholder="$t('phoneHint')"
            v-model="phone" />
          <p class="form-error-priadi" v-if="errors.phone">{{ errors.phone }}</p>
        </div>

        <div class="form-group">
          <label class="form-label-priadi" for="tgl_lahir">{{ $t('birthdate') }}</label>
          <input
            type="date"
            class="form-control-priadi"
            :class="{ 'is-invalid': errors.tgl_lahir }"
            id="tgl_lahir"
            :placeholder="$t('birthdateHint')"
            v-model="tgl_lahir" />
          <p class="form-error-priadi" v-if="errors.tgl_lahir">{{ errors.tgl_lahir }}</p>
        </div>

        <button class="btn-priadi btn-priadi-block form-submit" @click="submitForm">
          {{ $t('continue') }} <i class="bi bi-arrow-right"></i>
        </button>
      </div>
    </section>
  </div>

  <BottomNav />
</template>

<script>
import Navigation from '../components/Navigation'
import BottomNav from '../components/BottomNav'
import axios from 'axios'

export default {
  name: 'AddTransaction',
  components: { BottomNav, Navigation },
  data() {
    return {
      errors: {},
      nama: this.$store.getters.getUser.fullname,
      email: this.$store.getters.getUser.email,
      phone: this.$store.getters.getUser.phone_number,
      tgl_lahir: this.$store.getters.getUser.birthdate,
      pkg: {},
    }
  },
  mounted() {
    document.body.classList.add('body-tinted')
    this.pkg = this.$store.getters.getPackage
  },
  unmounted() {
    document.body.classList.remove('body-tinted')
  },
  methods: {
    formatPrice(price) {
      return 'Rp.' + Intl.NumberFormat('id').format(price) + ',-'
    },
    async submitForm() {
      this.errors = {}

      this.errors['nama'] = this.nama.length < 1 ? this.$t('validation.minLength', { field: this.$t('fullname'), min: 1 }) : ''
      this.errors['email'] = this.email.length < 3 ? this.$t('validation.minLength', { field: this.$t('email'), min: 3 }) : ''
      this.errors['tgl_lahir'] = !this.tgl_lahir ? this.$t('validation.required', { field: this.$t('birthdate') }) : ''
      this.errors['phone'] = !this.phone ? this.$t('validation.required', { field: this.$t('phone') }) : ''

      if (!this.errors['nama'] && !this.errors['email'] && !this.errors['tgl_lahir'] && !this.errors['phone']) {
        let self = this

        const formData = {
          user_id: this.$store.getters.getUser.id,
          fullname: this.nama,
          email: this.email,
          birthdate: this.tgl_lahir,
          phone: this.phone,
          language_id: 'id',
          package_id: this.pkg.id,
          package_name: this.pkg.name,
          is_hr: false,
          due_date: null,
          total_price: this.pkg.total_price,
          voucher_code: this.pkg.voucher_code ?? '',
          counselor_code: this.pkg.counselor_name ?? '',
          consultation_type: this.pkg.consultation_type ?? '',
        }

        await axios
          .post('/api/create_transaction', formData)
          .then((response) => {
            console.log(response)
            let transaction_id = response.data.transaction_id
            self.$store.dispatch('setTransaction', transaction_id)
            self.$router.push({ name: 'Upload Finger' })
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
  },
}
</script>

<style scoped>
/* Hero */
.detail-hero {
  position: relative;
}

/* Body content */
.detail-body {
  padding: 0 var(--space-4) calc(var(--space-16) + var(--space-10));
}

/* Summary card — overlaps hero, gradient from Package.vue */
.detail-summary {
  display: block;
  background-color: var(--color-surface);
  background-image: linear-gradient(
    to bottom,
    rgba(var(--color-primary-rgb), 0.08) 0%,
    rgba(var(--color-primary-rgb), 0.09) 40%,
    var(--color-surface) 100%
  );
  border: none;
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  font-family: var(--font-family);
  margin-top: -4em;
  position: relative;
  z-index: 1;
  margin-bottom: var(--space-6);
}

.pkg-name {
  display: block;
  color: var(--color-primary);
  font-size: var(--text-lg);
  font-weight: var(--font-bold);
  margin-bottom: var(--space-1);
}

.pkg-target {
  display: block;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  margin-bottom: var(--space-2);
}

.pkg-counselor {
  display: block;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  margin-bottom: var(--space-2);
}

.pkg-price {
  display: block;
  font-size: var(--text-xl);
  font-weight: var(--font-bold);
  color: var(--color-primary);
}

/* Section */
.detail-section {
  margin-bottom: var(--space-6);
}

/* Form card */
.form-card {
  padding: var(--space-6);
}

.form-card-title {
  font-size: var(--text-lg);
  font-weight: var(--font-bold);
  color: var(--color-text-primary);
  text-align: center;
  margin-bottom: var(--space-1);
}

.form-card-subtitle {
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  text-align: center;
  margin-bottom: var(--space-6);
}

/* Form groups */
.form-group {
  margin-bottom: var(--space-4);
}

.form-group:last-of-type {
  margin-bottom: var(--space-6);
}

/* Submit button */
.form-submit {
  border-radius: var(--radius-full);
  font-weight: var(--font-semibold);
}
</style>
